import React from 'react';

const InformationTab = ({ dataSource }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">name</span>
                <span className="db-list-item-text w-full sm:w-1/2">{dataSource?.name}</span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">Discount Percentage</span>
                <span className="db-list-item-text w-full sm:w-1/2">{dataSource?.discount_per}</span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">Start Date</span>
                <span className="db-list-item-text w-full sm:w-1/2">{dataSource?.start_date}</span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">End Date</span>
                <span className="db-list-item-text w-full sm:w-1/2">{dataSource?.end_date}</span>
            </div>

            <div className="db-list-item p-0">
                <span className="db-list-item-title w-full sm:w-1/2">status</span>
                <span className="db-list-item-text w-full sm:w-1/2">
                    {dataSource.status && dataSource.status == '1' ? <span className={'active'}>Active</span> : <span className={'inactive'}>Inactive</span>}
                </span>
            </div>
        </div>
    );
};

export default InformationTab;
